'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import CategoryQuickAccess from '@/components/common/CategoryQuickAccess';
import FeaturedProducts from './FeaturedProducts';
import BenefitsSection from './BenefitsSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import Footer from './Footer';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
    
    const loadCartCount = () => {
      try {
        const cartData = localStorage.getItem('wholesaleCart');
        if (cartData) {
          const cart = JSON.parse(cartData);
          const totalItems = cart.reduce((sum: number, item: any) => sum + (item.quantity || 0), 0);
          setCartCount(totalItems);
        }
      } catch (error) {
        console.error('Error loading cart:', error);
      }
    };

    loadCartCount();

    const handleStorageChange = () => {
      loadCartCount();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('cartUpdated', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cartUpdated', handleStorageChange);
    };
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header cartCount={0} />
        <main>
          <div className="h-96 bg-gradient-to-br from-primary to-secondary" />
          <div className="mx-auto max-w-7xl px-4 py-12">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="aspect-square rounded-md bg-card" />
              ))}
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header cartCount={cartCount} />
      
      <main>
        <HeroSection />
        
        <div className="mx-auto max-w-7xl px-4 py-12 lg:px-6">
          <CategoryQuickAccess variant="grid" maxVisible={6} />
        </div>
        
        <FeaturedProducts />
        
        <BenefitsSection />
        
        <TestimonialsSection />
        
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default HomepageInteractive;